export default __webpack_public_path__ + "img/devices.7da90536.png";